import { FaqRepository } from 'src/repositories/personalization/faq/faq.repository';
import { faqTypeItem } from 'src/types/faq';
import { api } from 'src/utils/axios';
import { create } from 'zustand';

type States = {
  isLoadingFaqList: boolean;
  isLoadingFaqDetails: boolean;
  isLoadingCreateFaq: boolean;
  isLoadingUpdateFaq: boolean;
  faqList: faqTypeItem[];
  faqDetails: faqTypeItem | null;
};

type Actions = {
  getFaqList: () => Promise<void>;
  getFaqDetails: (id: string) => Promise<void>;
  resetFaqDetails: () => void;
  createFaq: (faq: any) => Promise<void>;
  updateFaq: (faq: any) => Promise<void>;
};

type Faq = Actions & States;

const initialValues = {
  isLoadingFaqList: false,
  isLoadingFaqDetails: false,
  isLoadingCreateFaq: false,
  isLoadingUpdateFaq: false,
  faqList: [],
  faqDetails: null,
};

const faqRepository = new FaqRepository(api);

export const useFaqStore = create<Faq>((set: any, get: any) => ({
  ...initialValues,

  getFaqList: async () => {
    set({ isLoadingFaqList: true });
    const response = await faqRepository.getFaqList();

    if (response.isLeft()) {
      set({ isLoadingFaqList: false });
      throw new Error(response.value.message);
    } else {
      set({ faqList: response.value, isLoadingFaqList: false });
    }
  },

  getFaqDetails: async (id) => {
    set({ isLoadingFaqDetails: true });
    const response = await faqRepository.getFaqDetails(id);

    if (response.isLeft()) {
      set({ isLoadingFaqDetails: false });
      throw new Error(response.value.message);
    } else {
      set({ faqDetails: response.value, isLoadingFaqDetails: false });
    }
  },

  resetFaqDetails: () => {
    set({ faqDetails: null });
  },

  createFaq: async (faq) => {
    set({ isLoadingCreateFaq: true });

    const response = await faqRepository.createFaq(faq);
    if (response.isLeft()) {
      set({ isLoadingCreateFaq: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingCreateFaq: false });
    }
  },

  updateFaq: async (faq) => {
    set({ isLoadingUpdateFaq: true });

    const response = await faqRepository.updateFaq(faq);
    if (response.isLeft()) {
      set({ isLoadingUpdateFaq: false });
      throw new Error(response.value.message);
    } else {
      set({ isLoadingUpdateFaq: false });
    }
  },
}));
